var _excluded = ["typography", "type", "emphasis", "color", "hasCover", "to", "href", "title", "onClick", "onMouseEnter", "onMouseLeave", "openInNewTab", "rel", "children"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import transition from "../../../utils/transition";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
export var defaultProps = {
  emphasis: "high"
};
var StyledPlainLinkAtm = styled(Link).withConfig({
  componentId: "sc-x1j5qy-0"
})(function (_ref) {
  var $typography = _ref.$typography,
    $type = _ref.$type,
    _ref$$emphasis = _ref.$emphasis,
    $emphasis = _ref$$emphasis === void 0 ? defaultProps.emphasis : _ref$$emphasis,
    $color = _ref.$color,
    $hasCover = _ref.$hasCover,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  var commonStyles = {
    typography: $typography,
    onColor: $onColor,
    emphasis: $emphasis,
    color: $color
  };
  return css(["text-decoration:none;cursor:pointer;", ";", ";", ";", ";"], $type === "underline" && css(["", ";&:hover{text-decoration:underline;}"], cssTextAtm(_objectSpread({}, commonStyles))), $type === "opacity" && css(["", ";", ";&:hover,&:hover *{color:", ";}"], transition("color"), cssTextAtm(_objectSpread({}, commonStyles)), $color ? getColor(theme, $color, "hover") : getTextColor(theme, $onColor, $emphasis, "hover")), $type === "plain" && css(["", ";"], cssTextAtm(_objectSpread({}, commonStyles))), $hasCover && css(["&::after{", ";content:\"\";}"], cover()));
});
function PlainLinkAtm(_ref2) {
  var typography = _ref2.typography,
    type = _ref2.type,
    _ref2$emphasis = _ref2.emphasis,
    emphasis = _ref2$emphasis === void 0 ? defaultProps.emphasis : _ref2$emphasis,
    color = _ref2.color,
    hasCover = _ref2.hasCover,
    to = _ref2.to,
    href = _ref2.href,
    title = _ref2.title,
    onClick = _ref2.onClick,
    onMouseEnter = _ref2.onMouseEnter,
    onMouseLeave = _ref2.onMouseLeave,
    openInNewTab = _ref2.openInNewTab,
    rel = _ref2.rel,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledPlainLinkAtm, _extends({
    to: to,
    href: href,
    title: title,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    openInNewTab: openInNewTab,
    rel: rel,
    $typography: typography,
    $type: type,
    $emphasis: emphasis,
    $color: color,
    $hasCover: !!hasCover,
    $onColor: onColor
  }, restProps), children);
}
export default PlainLinkAtm;